import PatcraftApi from '../../../scripts/patcraft-api';

// Initial state
const state = () => ({
  selectedTab: 'collections', // options: 'collections', 'styles', 'page-content'
  searchTerm: null,
  collectionsPageNumber: 1,
  pagesPageNumber: 1,
  pageSize: 16,
  collections: [],
  pages: [],
  totalCollectionPages: 0,
  totalPagesPages: 0,
  fetchingCollections: false,
  fetchingPages: false,
});

// Getters
const getters = {
  selectedTab: (state, getters, rootState) => {
    return state.selectedTab;
  },
  searchTerm: (state) => {
    return state.searchTerm;
  },
  collectionsPageNumber: (state) => {
    return state.collectionsPageNumber;
  },
  pagesPageNumber: (state) => {
    return state.pagesPageNumber;
  },
  collections: (state) => {
    return state.collections;
  },
  pages: (state) => {
    return state.pages;
  },
  totalCollectionPages: (state) => {
    return state.totalCollectionPages;
  },
  totalPagesPages: (state) => {
    return state.totalPagesPages;
  },
  fetchingCollections: (state) => {
    return state.fetchingCollections;
  },
  fetchingPages: (state) => {
    return state.fetchingPages;
  },
};

// Mutations
const mutations = {
  setSelectedTab(state, { tab }) {
    state.selectedTab = tab;
  },
  setSearchTerm(state, { term }) {
    state.searchTerm = term;
  },
  setCollectionsPageNumber(state, { number }) {
    state.collectionsPageNumber = number;
  },
  setPagesPageNumber(state, { number }) {
    state.pagesPageNumber = number;
  },
  setPages(state, { results }) {
    state.pages = [...results];
  },
  setCollections(state, { results }) {
    state.collections = [...results];
  },
  setCollTotalPages(state, { pagesCount }) {
    state.totalCollectionPages = pagesCount;
  },
  setPagesTotalCount(state, { pagesCount }) {
    state.totalPagesPages = pagesCount;
  },
  setFetchingPages(state, { value }) {
    state.fetchingPages = value;
  },
  setFetchingCollections(state, { value }) {
    state.fetchingCollections = value;
  },
};

// Actions
const actions = {
  setSelectedTab({ commit, state }, id) {
    commit('setSelectedTab', { tab: id });
  },
  setSearchTerm({ commit, state }, term) {
    commit('setSearchTerm', { term });
  },
  setCollectionsPageNumber({ commit, state }, number) {
    commit('setCollectionsPageNumber', { number });
  },
  setPagesPageNumber({ commit, state }, number) {
    commit('setPagesPageNumber', { number });
  },
  setFetchingPages({ commit, state }, value) {
    commit('setFetchingPages', { value });
  },
  setFetchingCollections({ commit, state }, value) {
    commit('setFetchingCollections', { value });
  },
  fetchPagesResults({ commit, state, dispatch }) {
    if (state.fetchingPages) {
      return;
    }
    dispatch('setFetchingPages', true);
    PatcraftApi.getPagesResults(state.searchTerm, state.pagesPageNumber, state.pageSize).then((res) => {
      let results = [...res.data.items]
      if (state.pagesPageNumber > 1) {
        results = [...state.pages, ...res.data.items];
      }
      commit('setPages', { results });
      commit('setPagesTotalCount', { pagesCount: res.data.totalPages });
      dispatch('setFetchingPages', false);
    }).catch(() => {
      dispatch('setFetchingPages', false);
    })
  },
  fetchCollectionsResults({ commit, state, dispatch }) {
    if (state.fetchingCollections) {
      return;
    }
    dispatch('setFetchingCollections', true);
    PatcraftApi.getCollectionsResults({
      SearchTerm: state.searchTerm,
      PageNumber: state.collectionsPageNumber,
      PageSize: state.pageSize,
    }).then((res) => {
      let results = [...res.data.items];

      if (!results.length) {
        dispatch('setSelectedTab', 'styles');
      }

      if (state.collectionsPageNumber > 1) {
        results = [...state.collections, ...res.data.items];
      }
      commit('setCollections', { results });
      commit('setCollTotalPages', { pagesCount: res.data.totalPages });
      dispatch('setFetchingCollections', false);
    }).catch(() => {
      dispatch('setFetchingCollections', false);
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}